import { SiteHelper } from '../../common/utils/SiteHelper';

const MemberHomeRedirector = (element) => {
    if (!element) {
        return;
    }

    const tryRedirect = element.querySelector('.js-member-home-redirect');

    if (tryRedirect && !SiteHelper.isIntranetSite()) {
        //check if the user can/needs to be redirect to the memeber home page
        SiteHelper.tryRedirectToMemberHome();
    }
};

export { MemberHomeRedirector };


// WEBPACK FOOTER //
// ./src/nams2020/webparts/MemberHomeRedirector/index.js